export const SET_LIVESWITCH_INSTANCE = "SET_LIVESWITCH_INSTANCE";

export const SEND_CHAT = "SEND_CHAT";
export const RECEIVE_CHAT = "RECEIVE_CHAT";

export const REMOTE_VIDEO_DEVICE_LIST_RECEIVED = "REMOTE_VIDEO_DEVICE_LIST_RECEIVED";
export const LOCAL_VIDEO_DEVICE_LIST_RECEIVED = "LOCAL_VIDEO_DEVICE_LIST_RECEIVED";
export const CLIENT_VIDEO_DEVICE_LIST_RECEIVED = "CLIENT_VIDEO_DEVICE_LIST_RECEIVED";
export const IMAGE_STILL_FOR_AI_RECEIVED = "IMAGE_STILL_FOR_AI_RECEIVED";

export const CONNECTION_QUALITY_PING = "CONNECTION_QUALITY_PING";
export const CONNECTION_QUALITY_PING_RECEIVED = "CONNECTION_QUALITY_PING_RECEIVED";
export const CONNECTION_QUALITY_BELOW_THRESHOLD = "CONNECTION_QUALITY_BELOW_THRESHOLD";
export const CONNECTION_QUALITY_EXCEEDS_THRESHOLD = "CONNECTION_QUALITY_EXCEEDS_THRESHOLD";
export const DISMISS_CONNECTION_QUALITY_WARNING = "DISMISS_CONNECTION_QUALITY_WARNING";
export const DISPLAY_CONNECTION_QUALITY_WARNING = "DISPLAY_CONNECTION_QUALITY_WARNING";
export const ISSUE_CLIENT_CONNECTION_QUALITY_WARNING = "ISSUE_CLIENT_CONNECTION_QUALITY_WARNING";
export const CANCEL_CLIENT_CONNECTION_QUALITY_WARNING = "CANCEL_CLIENT_CONNECTION_QUALITY_WARNING";

export const PHOTO_REQUEST_RECEIVED = "PHOTO_REQUEST_RECEIVED";
export const PHOTO_URL_RECEIVED = "PHOTO_URL_RECEIVED";
export const PHOTO_DATA_RECEIVED = "PHOTO_DATA_RECEIVED";

export const VIDEO_FRAME_TAG_PHOTO_URL_RECEIVED = "VIDEO_FRAME_TAG_PHOTO_URL_RECEIVED";

export const TOGGLE_LOCAL_VIDEO = "TOGGLE_LOCAL_VIDEO";
export const TOGGLE_LOCAL_AUDIO = "TOGGLE_LOCAL_AUDIO";

export const SET_LOCAL_VIDEO_INPUT = "SET_LOCAL_VIDEO_INPUT";

export const LOCAL_AUDIO_INPUT_LIST_RECEIVED = "LOCAL_AUDIO_INPUT_LIST_RECEIVED";
export const LOCAL_AUDIO_OUTPUT_LIST_RECEIVED = "LOCAL_AUDIO_OUTPUT_LIST_RECEIVED";
export const SESSION_ENDED_RECEIVED = "SESSION_ENDED_RECEIVED";

export const COMMAND_SEND_PHOTO_URL = "COMMAND_SEND_PHOTO_URL";
export const COMMAND_SEND_VIDEO_FRAME_TAG_PHOTO_URL = "COMMAND_SEND_VIDEO_FRAME_TAG_PHOTO_URL";
export const TAKE_LOCAL_MEDIA_PHOTO = "TAKE_LOCAL_MEDIA_PHOTO";
export const COMMAND_REQUEST_PHOTO = "COMMAND_REQUEST_PHOTO";
export const COMMAND_MUTE_REMOTE_CAMERA = "COMMAND_MUTE_REMOTE_CAMERA";
export const COMMAND_CHANGE_REMOTE_CAMERA = "COMMAND_CHANGE_REMOTE_CAMERA";
export const COMMAND_TOGGLE_RECORDING = "COMMAND_TOGGLE_RECORDING";
export const COMMAND_SESSION_ENDED = "COMMAND_SESSION_ENDED";
export const COMMAND_MUTE_REMOTE_AUDIO = "COMMAND_MUTE_REMOTE_AUDIO";
export const CLIENT_AUDIO_MUTE_UPDATED = "CLIENT_AUDIO_MUTE_UPDATED";
export const CURRENT_ADD_PHOTO_TAG_OPTIMISTIC = "CURRENT_ADD_PHOTO_TAG_OPTIMISTIC";

export const SET_GUEST_ACTIVE_STATE = "SET_GUEST_ACTIVE_STATE";

export const NETWORK_STATUS_UPDATED = "NETWORK_STATUS_UPDATED";

export const SET_CAMERA_BUSY_STATUS = "SET_CAMERA_BUSY_STATUS";

export const AUDIO_MUTE_CONFIRMATION_STATE_UPDATED = "AUDIO_MUTE_CONFIRMATION_STATE_UPDATED";
export const VIDEO_MUTE_CONFIRMATION_STATE_UPDATED = "VIDEO_MUTE_CONFIRMATION_STATE_UPDATED";
export const CHANGE_CAMERA_CONFIRMATION_UPDATED = "CHANGE_CAMERA_CONFIRMATION_UPDATED";
export const COMMAND_SEND_PHOTO_REMOVED = "COMMAND_SEND_PHOTO_REMOVED";

export const PHOTO_REMOVED = "PHOTO_REMOVED";
export const SET_LOCAL_AUDIO_OUTPUT = "SET_LOCAL_AUDIO_OUTPUT";

export const SET_CANVAS_REDUCER_QUALITY = "SET_CANVAS_REDUCER_QUALITY";
export const SEND_CANVAS_QUALITY_COMMAND = "SEND_CANVAS_QUALITY_COMMAND";
export const SET_LOCAL_AUDIO_INPUT = "SET_LOCAL_AUDIO_INPUT";
export const RECORDING_TOGGLED = "RECORDING_TOGGLED";

export const GET_AUDIO_OUTPUT_DEVICES = "GET_AUDIO_OUTPUT_DEVICES";
